/** @jsx jsx */
import { Flex, Toast as IrisToast } from "@eworkit/iris";
import { FC } from "react";
import { jsx } from "theme-ui";

interface ToastProps {
  onClose: () => void;
  text: string;
  type: "success" | "information" | "warning" | "danger";
}

export const Toast: FC<ToastProps> = ({ text, type, onClose }) => {
  setTimeout(() => {
    onClose();
  }, 3000);

  return (
    <Flex>
      <IrisToast
        onClose={onClose}
        text={text}
        variant={type}
        sx={{
          width: ["calc(100vw - 48px)", null, "auto"],
        }}
      />
    </Flex>
  );
};
